import axios from 'axios'

export function localIdLogin (params) {
  return new Promise(function (resolve, reject) {
    callApi(process.env.LOCAL_ID_LOGIN, params)
      .then(res => { resolve(res) })
      .catch(error => { reject(error) })
  })
}

export function localIdUserCheck (params) {
  return new Promise(function (resolve, reject) {
    callApi(process.env.LOCAL_ID_USER_CHECK, params)
      .then(res => { resolve(res) })
      .catch(error => { reject(error) })
  })
}

export function localIdUserDataValidate (params) {
  return new Promise(function (resolve, reject) {
    callApi(process.env.LOCAL_ID_USER_DATA_VALIDATE, params)
      .then(res => { resolve(res) })
      .catch(error => { reject(error) })
  })
}

export function localIdUserLocalIdRegister (params) {
  return new Promise(function (resolve, reject) {
    callApi(process.env.LOCAL_ID_LOCAL_ID_REGISTER, params)
      .then(res => { resolve(res) })
      .catch(error => { reject(error) })
  })
}

function callApi (url, params) {
  return new Promise(function (resolve, reject) {
    axios.post(url, JSON.stringify(params), {headers: {'Content-Type': 'application/json'}})
      .then(res => {
        let result = res.data
        // console.log('res', result)
        if (result.status === '1') {
          reject(new Error(result.error_message))
        }
        resolve(result)
      })
      .catch(error => {
        reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/utils/LocalLoginHelper.js